export default __webpack_public_path__ + "static/media/people.4f506fd1.jpg";